import type { Component } from '@ydegouvello/ui';
import { SessionsRepository } from 'repositories/sessions.repository';
import { AbstractComponent } from './abstract.component';

export class LoginComponent extends AbstractComponent {
  private static _instance: LoginComponent | undefined = undefined;

  private constructor(
    name: string,
    parent?: { readonly containerHtmlElementSelector: string; readonly component: Component },
    readonly sessionRepository: SessionsRepository = SessionsRepository.getInstance(),
  ) {
    super(name, parent);
  }

  static getInstance(
    name = 'login',
    parent?: { readonly containerHtmlElementSelector: string; readonly component: Component },
    sessionRepository: SessionsRepository = SessionsRepository.getInstance(),
  ): LoginComponent {
    this._instance ??= new this(name, parent, sessionRepository);
    return this._instance;
  }

  protected override async render(): Promise<void> {
    const session = await this.sessionRepository.get();
    if (!session) throw new Error('Session not found');
    if (session.active) throw new Error('Session is already active');

    this.getById('login-error').style.display = 'none';
    this.getById('login-form').addEventListener(
      'submit',
      (event) =>
        void (async () => {
          event.preventDefault();

          const code = this.getById<HTMLInputElement>('login-code').value.trim();
          if (!code) return;

          await this.safeCall(async () => {
            await this.setLoading(true);

            const session = await this.sessionRepository.login(code);
            await this.setLoading(false);
            if (session && !session.active) {
              console.error('Wrong code');
              this.getById('login-error').style.display = 'block';
              return;
            }
            this.getById('login-error').style.display = 'none';
            if (!session) {
              console.error('Login failed (no session)');
              await this.sessionRepository.logout();
            }
            await this.navigation.refresh();
          });
        })(),
    );

    this.setLogoutHandler();
  }

  private setLogoutHandler() {
    this.getById('cancel-button').addEventListener(
      'click',
      (event) =>
        void (async () => {
          event.preventDefault();

          await this.safeCall(async () => {
            await this.setLoading(true);

            try {
              await this.sessionRepository.logout();
              await this.navigation.refresh();
              console.log('Logged out');
            } catch (error) {
              console.error('Failed to logout', error);
            } finally {
              await this.setLoading(false);
            }
          });
        })(),
    );
  }
}
